import React from "react";
import "./component_style.css";

export default () => (
  <div className="Footer">
    <div className="container">
      <span className="logo-text">{(new Date()).getFullYear()} © Soloway</span>
      <span style={{marginLeft: '24px'}}>Получение статистики по API. <a href="/API_doc.pdf">Документация</a>.</span>
    </div>
  </div>
);
